// src/components/practice/tasks/writing/parsers/osdB2FlyerParser.js
// Parser for OSD B2 Formal Letter flyer content with notes

export const parseOsdB2FlyerContent = (content) => {
    if (!content) return null;

    const lines = content.split('\n').map(line => line.trim()).filter(Boolean);
    const result = {
        title: '',
        subtitle: '',
        sections: [],
        footer: []
    };

    let currentSection = null;
    let lastListItem = null;
    let inFooter = false;

    for (let i = 0; i < lines.length; i++) {
        const line = lines[i];

        // Parse title (### with optional emojis)
        if (line.startsWith('###')) {
            result.title = line.replace(/###/g, '').trim();
        }
        // Parse subtitle (text with emojis or special formatting)
        else if (line.includes('🌟') || (line.includes('*') && !line.startsWith('**') && !result.subtitle && !line.startsWith('>'))) {
            result.subtitle = line.replace(/\*\*/g, '').replace(/🌟/g, '').replace(/[„""]/g, '').replace(/\*/g, '').trim();
        }
        // Parse notes - must come AFTER list items
        else if (line.startsWith('>') && line.includes('Ihre Notiz:')) {
            const noteText = line.replace(/^>\s*\*?/, '').replace(/\*$/, '').replace('Ihre Notiz:', '').trim();

            // Attach note to last list item
            if (lastListItem) {
                lastListItem.note = noteText;
            }
        }
        // Detect footer section
        else if (line.startsWith('**Kursgebühr') || line.startsWith('**Anmeldung') || line.startsWith('**Bewerben') || line.includes('Bewerben Sie sich')) {
            inFooter = true;
            result.footer.push(line.replace(/\*\*/g, ''));
        }
        // Continue collecting footer
        else if (inFooter) {
            result.footer.push(line.replace(/\*\*/g, ''));
        }
        // Parse bullet items with •
        else if (line.startsWith('•')) {
            // Create a section if we don't have one yet
            if (!currentSection) {
                currentSection = {
                    header: '',
                    items: []
                };
                result.sections.push(currentSection);
            }

            // Extract header and description from same line
            const cleanLine = line.replace(/^•\s*/, '');
            const headerMatch = cleanLine.match(/\*\*(.+?)\*\*/);

            if (headerMatch) {
                const header = headerMatch[1];
                const description = cleanLine.replace(/\*\*.*?\*\*/, '').trim();

                lastListItem = {
                    header: header,
                    text: description,
                    note: null
                };
                currentSection.items.push(lastListItem);
            } else {
                // No header, just text
                lastListItem = {
                    header: '',
                    text: cleanLine.replace(/\*\*/g, ''),
                    note: null
                };
                currentSection.items.push(lastListItem);
            }
        }
        // Parse section headers ending with :** (for older format)
        else if (line.startsWith('**') && line.includes(':**')) {
            const headerMatch = line.match(/\*\*(.+?):\*\*/);
            const description = line.split(':**')[1]?.replace(/\*\*/g, '').trim() || '';

            currentSection = {
                header: headerMatch ? headerMatch[1] : '',
                items: []
            };
            result.sections.push(currentSection);

            // Add description as item if exists
            if (description) {
                lastListItem = {
                    header: '',
                    text: description,
                    note: null
                };
                currentSection.items.push(lastListItem);
            }
        }
    }

    console.log('Parsed OSD B2 flyer content:', result);
    return result;
};